export default {
  NOTICE_PERSON: { value: 1, label: "个人" },
  NOTICE_ALL: { value: 2, label: "所有人" },
}
